import { WSElement, WSImage, WSText } from "@wingspanhq/fe-component-library";
import { WingspanProducts } from "@wingspanhq/users/dist/lib/interfaces";
import * as React from "react";
import { useHistory } from "react-router-dom";
import logo from "../../assets/images/ws-logo.svg";
import { Fullscreen } from "../../components/Fullscreen/Fullscreen";
import { useCMSWebflowEnterprise } from "../../query/cms/queries";
import { useUserId } from "../../query/hooks/helpers";
import { useEnterpriseQuery } from "../../query/platform/queries";
import { getCurrentEntepriseId } from "../../query/platform/selectors";
import { useMemberProfile } from "../../query/users/queries";
import { WSQueries } from "../../query/WSQuery";
import { useSetWSStore, useWSStore } from "../../store";
import { ProgressBar } from "../components/ProgressBar/ProgressBar";
import styles from "./OnboardingCustomizing.module.scss";

export const OnboardingCustomizing: React.FC = () => {
  const history = useHistory();
  const userId = useUserId();
  const memberQuery = useMemberProfile(userId);
  const setStore = useSetWSStore();
  const store = useWSStore();

  const enterpriseQuery = useEnterpriseQuery();

  return (
    <WSQueries queries={{ memberQuery }}>
      {({ memberQuery: { data: member } }) => (
        <Fullscreen>
          <WSElement className={styles.wrapper}>
            <WSElement className={styles.container}>
              <WSImage
                className={styles.logo}
                src={logo}
                placeholder={<WSText.Heading1>Wingspan</WSText.Heading1>}
                mb="XL"
              />
              <ProgressBar
                mb="XL"
                ms={1000}
                onComplete={() => {
                  if (store.signUpHash) {
                    const hash = store.signUpHash.slice(1);
                    setStore({ signUpHash: undefined });
                    history.push(hash);
                  } else if (enterpriseQuery.data?.is1099FilingOnly) {
                    history.push("/member/1099-filing/onboarding");
                  } else if (
                    store.isEmployerSignUp ||
                    member.profile.productImportance?.[0] ===
                      WingspanProducts.Payments
                  ) {
                    setStore({ productActivationAfterOnboarding: true });
                    history.push("/member/invoices");
                  } else if (
                    member.profile.productImportance?.[0] ===
                    WingspanProducts.Bookkeeping
                  ) {
                    setStore({ productActivationAfterOnboarding: true });
                    history.push("/member/bookkeeping/setup");
                  } else if (
                    member.profile.productImportance?.[0] ===
                    WingspanProducts.Benefits
                  ) {
                    setStore({ productActivationAfterOnboarding: true });
                    history.push("/member/benefits");
                  } else {
                    history.push("/member/dashboard");
                  }
                }}
              />
              <WSText>Personalizing your Wingspan experience</WSText>
            </WSElement>
          </WSElement>
        </Fullscreen>
      )}
    </WSQueries>
  );
};
